import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import PercentIcon from '@mui/icons-material/Percent';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import useDiscountPanel from './hooks/useDiscountPanel';

type DiscountPanelProps = {
  discountPanelState: ReturnType<typeof useDiscountPanel>;
};

const DiscountPanel: FC<DiscountPanelProps> = ({ discountPanelState }) => {
  const { t } = useTranslation(['orders']);

  const { discount, validationErrors, setDiscount, onValidate } =
    discountPanelState;

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Typography variant='body1' sx={{ mb: 2 }}>
        {t('orders:discountPercent')}
      </Typography>

      <TextField
        fullWidth
        label='Discount'
        placeholder='Provide a discount ...'
        value={discount}
        error={!!validationErrors.discount}
        helperText={validationErrors.discount}
        inputProps={{ type: 'number', min: 0, max: 99 }}
        InputProps={{
          endAdornment: (
            <PercentIcon
              sx={{ color: 'text.secondary', width: 20, height: 20 }}
            />
          ),
        }}
        onChange={(e) => setDiscount(e.target.value)}
        onBlur={onValidate}
      />
    </Paper>
  );
};

export default DiscountPanel;
